export default class CopyText {
    static init(): void {
        // Funkce pro inicializaci kopírování
        function initCopyText(): void {
            // Najdi všechny prvky s třídou 'js-copy-text'
            const copyElements = document.querySelectorAll('.js-copy-text');

            // Pokud žádné prvky neexistují, funkci neprováděj
            if (copyElements.length === 0) {
                //console.log('Žádné prvky s třídou .js-copy-text nebyly nalezeny.');
                return;
            }

            // Přidej událost pro každý prvek
            copyElements.forEach((element) => {
                const trigger = element.querySelector('.copy-text__trigger');
                const content = element.querySelector('.copy-text__content');

                // Pokud existuje trigger a content, nastav událost
                if (trigger && content) {
                    trigger.addEventListener('click', () => {
                        const textToCopy = content.textContent || '';

                        // Zkopírování textu do schránky
                        navigator.clipboard.writeText(textToCopy).then(() => {
                            //alert('Zkopírováno do schránky!');
                        }).catch(err => {
                            console.error('Chyba při kopírování: ', err);
                        });
                    });
                }
            });
        }

        if (document.querySelector('.js-copy-text')) {
            initCopyText();
        }
    }
}